
import { baseClasses } from '@weatherbug/common';
import { AlmanacResultType } from '../actions/solarActions';

const solarDataByLatLngUri = 'api/almanac';
const solarDataByLatLngKey = 'webalmanackey';

const { PulseBaseProvider } = baseClasses;

const getSolarDataValidationFunction = (result: AlmanacResultType) => {
    return result.Solar?.length > 0;
};

export class SolarProvider extends PulseBaseProvider {
    constructor(authId?: string, secret?:string, options?: any, logger?: any) {
        super(authId, secret, options, logger);
        window.storage.sync[solarDataByLatLngKey] = this.getSolarDataByLatLngSyncer.bind(this);
    }

    async getSolarDataByLatLngSyncer(params: any) {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        const { lat, lng, count } = JSON.parse(id);
        const queryParams = {
            lat,
            lng,
            count
        };
        return await super.syncData(key, id, queryParams, solarDataByLatLngUri, resolve, reject, getSolarDataValidationFunction, pulseApi, null, null, false);
    }
    
    async getSolarDataByLatLng(lat: number, lng: number, count = 1) {
        const syncParams = {
            lat,
            lng,
            count
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(solarDataByLatLngKey, id, syncParams);
    }
}
